<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import { chunk } from 'lodash-es'
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

// import '~/css/fancybox.css'
import UiAsset from '~/components/ui/ui-asset.vue'
import Thumbnails from '~/assets/gallery/720'
import Larges from '~/assets/gallery/1920'

const { t } = useI18n()

onMounted(() => {
  Fancybox.bind('[data-fancybox]', {
    Thumbs: {
      type: 'modern',
    },
  })
})

useHead({
  title: computed(() => `${t('modules.nav.gallery')} - ${t('project.name')}`),
})

const gridThumbnails = chunk(Thumbnails, 3)
const gridLarges = chunk(Larges, 3)
</script>

<template>
  <section class="max-w-7xl mx-auto p-8 md:py-16">
    <div class="flex flex-wrap -m-1 md:-m-2">
      <div v-for="(group, idx) in gridThumbnails"
           :key="idx"
           class="flex justify-end flex-col flex-wrap w-full md:w-1/2 md:even:flex-col-reverse"
      >
        <div class="w-full p-1 md:p-2">
          <div class="aspect-[5/3]">
            <UiAsset alt="gallery"
                     class="object-center object-cover rounded-lg w-full h-full cursor-pointer"
                     data-fancybox="gallery"
                     :data-thumb="gridLarges[idx][0]"
                     :data-src="gridLarges[idx][0]"
                     :src="group[0]"
            />
          </div>
        </div>
        <div class="w-full flex">
          <div v-if="group[1]"
               class="w-1/2 p-1 md:p-2"
          >
            <div class="aspect-[5/3]">
              <UiAsset alt="gallery"
                       class="object-center object-cover rounded-lg w-full h-full cursor-pointer"
                       data-fancybox="gallery"
                       :data-thumb="gridLarges[idx][1]"
                       :data-src="gridLarges[idx][1]"
                       :src="group[1]"
              />
            </div>
          </div>
          <div v-if="group[2]"
               class="w-1/2 p-1 md:p-2"
          >
            <div class="aspect-[5/3]">
              <UiAsset alt="gallery"
                       class="object-center object-cover rounded-lg w-full h-full cursor-pointer"
                       data-fancybox="gallery"
                       :data-thumb="gridLarges[idx][2]"
                       :data-src="gridLarges[idx][2]"
                       :src="group[2]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
